document.addEventListener('click', function (e) {
  if (!e.target.closest('.diip-header__has-dropdown')) {
    document.querySelectorAll('.diip-header__has-dropdown.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      item.querySelector('.diip-header__nav-link').setAttribute('aria-expanded', 'false');
    });
  }
});

/* ---------------------------------------------------------------------
   DIIP UPDATE: Mobile Hamburger + Drawer Menu
   เปิด/ปิด Drawer, และ Accordion เมนูย่อยข้างในสำหรับเมนูที่มี Dropdown
--------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.diip-header');
  if (!header) return;

  var openBtn = header.querySelector('[data-mobile-menu-open]');
  var closeBtn = header.querySelector('[data-mobile-menu-close]');
  var overlay = header.querySelector('[data-mobile-menu-overlay]');
  var drawer = header.querySelector('[data-mobile-menu-drawer]');

  function openMobileMenu() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('diip-mobile-menu-open');
  }

  function closeMobileMenu() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('diip-mobile-menu-open');
  }

  if (openBtn) openBtn.addEventListener('click', openMobileMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMobileMenu);
  if (overlay) overlay.addEventListener('click', closeMobileMenu);

  document.addEventListener('keyup', function (e) {
    if (e.code === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  // Accordion เมนูย่อยข้างใน Drawer (เมนูที่ติ๊ก "เปิด Dropdown" ไว้)
  if (drawer) {
    drawer.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        var parentItem = toggleBtn.closest('.diip-header__mobile-has-dropdown');
        if (!parentItem) return;
        var isOpen = parentItem.classList.toggle('is-open');
        toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }
});
